import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Field } from './styles';
import { TwoFAFormProps } from './types';
import { ZigInputCode, ZigTypography } from '@zignaly-open/ui';

function TwoFAForm({
  onSubmit,
  onChange,
  isLoading,
  clearOnError,
  error = null,
  autoFocus = false,
  prefixId = 'ask-2fa-modal',
}: TwoFAFormProps) {
  const { t } = useTranslation('auth');
  return (
    <Layout>
      <Field>
        <ZigTypography id={`${prefixId}__description`}>
          {t('auth-verify-modal.isNotDisabled.ask2FA.twoFA-description')}
        </ZigTypography>
        <ZigInputCode
          prefixId={prefixId}
          fields={6}
          error={error}
          loading={isLoading}
          clearOnError={clearOnError}
          onComplete={onSubmit}
          onChange={onChange}
          autoFocus={autoFocus}
        />
      </Field>
    </Layout>
  );
}

export default TwoFAForm;
